// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
  /* eslint-disable no-unused-vars */
  Style,
  // basic
  Button,
  Loading,
  Tip,
  Toolbar,
  TabBar,
  TabPanels,
  // form
  Checkbox,
  CheckboxGroup,
  Checker,
  Radio,
  RadioGroup,
  Input,
  Textarea,
  Select,
  Switch,
  Rate,
  Validator,
  Upload,
  Form,
  // popup
  Popup,
  Toast,
  Picker,
  CascadePicker,
  DatePicker,
  TimePicker,
  SegmentPicker,
  Dialog,
  ActionSheet,
  Drawer,
  ImagePreview,
  // scroll
  Scroll,
  Slide,
  IndexList,
  Swipe,
  Sticky,
  ScrollNav,
  ScrollNavBar,
  RecycleList
} from 'cube-ui'
import App from './App'
import router from './router'
import BottomTabBar from '@/components/common/BottomTabBar'
import installGoUrl from '@/utils/goUrl'

Vue.use(Button)
Vue.use(Loading)
Vue.use(Tip)
Vue.use(Toolbar)
Vue.use(TabBar)
Vue.use(TabPanels)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Checker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Input)
Vue.use(Textarea)
Vue.use(Select)
Vue.use(Switch)
Vue.use(Rate)
Vue.use(Validator)
Vue.use(Upload)
Vue.use(Form)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(CascadePicker)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(SegmentPicker)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Drawer)
Vue.use(ImagePreview)
Vue.use(Scroll)
Vue.use(Slide)
Vue.use(IndexList)
Vue.use(Swipe)
Vue.use(Sticky)
Vue.use(ScrollNav)
Vue.use(ScrollNavBar)
Vue.use(RecycleList)

Vue.component('BottomTabBar', BottomTabBar)
installGoUrl(Vue)

Vue.config.productionTip = false

// 全局后退方法：组件内可直接 @click="handleBack()"
// - 有 history：router.back()
// - 无 history（例如首次打开详情页）：回到首页或指定 fallback
Vue.mixin({
  methods: {
    handleBack (fallback = '/') {
      const r = this && this.$router
      if (!r) {
        try {
          window.history.back()
        } catch (e) {}
        return
      }
      try {
        if (window.history && window.history.length > 1) {
          r.back()
        } else {
          r.replace(fallback || '/')
        }
      } catch (e) {
        try {
          r.replace(fallback || '/')
        } catch (err) {}
      }
    }
  }
})

// 移除浏览器扩展注入的 caoliao 元素
function removeCaoliaoExt () {
  const ids = ['__caoliao-browser-ext-root', '__caoliao-browser-ext']
  ids.forEach(id => {
    const el = document.getElementById(id)
    if (el) el.remove()
  })
}
removeCaoliaoExt()
document.addEventListener('DOMContentLoaded', removeCaoliaoExt)
if (document.body) {
  const observer = new MutationObserver(removeCaoliaoExt)
  observer.observe(document.body, { childList: true, subtree: true })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js